import { REVALIDATE_PERIOD } from '@/_constants/env';
import { fetchWithoutDuplicates } from '@/api/utils/fetch-without-duplicates';

type TParams = {
  url: string;
  body: string;
  revalidate?: number;
};

export const isrFetch = async <TResponse>(
  params: TParams,
): Promise<TResponse | null> => {
  try {
    const { url, body, revalidate = REVALIDATE_PERIOD } = params;
    const response = await fetchWithoutDuplicates<TResponse>({
      url,
      method: 'POST',
      next: {
        revalidate,
      },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body,
      credentials: 'include',
    });

    return response?.result ?? null;
  } catch (error) {
    console.error(`isrFetch: Network response was not ok ${error}`);
    console.error(`isrFetch: Request params: ${JSON.stringify(params)}`);
    if (error instanceof TypeError && error.cause) {
      console.error('isrFetch cause:', error.cause);
    }

    return null;
  }
};
